import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'
import { DateRange } from '../../lib/types/DateRange'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'

export type StockMetricsType = Array<{
  upload_id: number
  date: string
  amount_local: number
  amount_target: number
  local_currency_code: string
  local_currency: string
  local_currency_symbol: string
  target_currency_code: string
  target_currency: string
  target_currency_symbol: string
  sale_rate: number
  purchase_rate: number
  gain_strategy: number
  purchase_date: string
}>
export const useGetStockMetrics = ({
  dateRange,
}: {
  dateRange: DateRange
}): UseQueryResult<StockMetricsType, Error> => {
  const queryParams = useBuildQueryParams(dateRange.dateRange)

  return useQuery(['reports', 'stocks', 'metrics', { queryParams }], () =>
    request<StockMetricsType>({
      url: '/reports/stocks/metrics',
      method: 'GET',
      params: {
        ...queryParams,
      },
    }),
  )
}
